import { ProjectViewModel } from "../../ViewModel/ProjectViewModel";
import { FtlRouteViewModel } from "../../ViewModel/FtlRouteViewModel";
import { PdsrClientViewModel } from "../../ViewModel/PdsrClientViewModel";

export const updatePdsrFTLIdentifier = (project: ProjectViewModel) => {
  project.PdsrsOnThisProject?.forEach((pdsrOnProject: PdsrClientViewModel) => {
    pdsrOnProject.UsedInFtlRoutes = 0;
  });

  project.FTLRoutes?.forEach((ftlRouteItem: FtlRouteViewModel) => {
    if (ftlRouteItem.IsExpired) {
      return;
    }
    ftlRouteItem.PdsrsOnThisRoute?.forEach((pdsrOnThisRouteItem: PdsrClientViewModel) => {
      const index = project.PdsrsOnThisProject?.findIndex(
        (pdsr) =>
          pdsr.ContainerNetwork === pdsrOnThisRouteItem.ContainerNetwork &&
          pdsr.SupplierGsdb === pdsrOnThisRouteItem.SupplierGsdb &&
          pdsr.PlantGsdb === pdsrOnThisRouteItem.PlantGsdb &&
          pdsr.DockCode === pdsrOnThisRouteItem.DockCode
      );
      project.PdsrsOnThisProject![index as number].UsedInFtlRoutes! += 1;
    });
  });
  return project;
};
